import { takeLatest, call, put } from "redux-saga/effects"

import { push } from "connected-react-router"
import axios from "axios"
import {
  SAVE_TEMPLATE_WATCHER,
  CLOSE_IMPORT,
  UPLOAD_TEMPLATE_WATCHER,
  GET_DIVISIONS_SUMMARY_WATCHER,
} from "./constants"
// Individual exports for testing
import {
  saveTemplateSuccess,
  saveTemplateProgress,
  uploadTemplateSuccess,
  uploadTemplateFailed,
} from "./actions"

import { importDivisionSegment } from "../../utils/segment/Division/divisionTrack"
import { LOCAL_COMPANY_ID, LOCAL_TOKEN } from "../../utils/storage"

function messageProgress(messagex) {
  message.loading(messagex, 0)
}

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}

// import {
//   // hasDivisionsWatcher,
//   // uploadTemplateFailed,
//   // uploadTemplateSuccess
// } from '../Division/actions'

// UPLOAD TEMPLATE
function uploadTemplate(payload) {
  return axios.request({
    method: "post",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/divisions/import/xlsx`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: payload,
  })
}

function uploadTemplateProgress(payload) {
  return axios.request({
    method: "get",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/divisions/import/xlsx/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: payload,
  })
}

function uploadTemplateSummaryApi() {
  return axios.request({
    method: "get",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/divisions/import/xlsx/summary`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
  })
}

function* uploadTemplateSummary(action) {
  try {
    const data = yield call(uploadTemplateSummaryApi)

    if (data.status === 200) {
      yield put(uploadTemplateSuccess(data.data[0]))
    }
  } catch (err) {
    yield call(messageFailed, "Error al cargar detalles")
    yield put(push("/organization#divisions"))
  }
}

export function* uploadTemplateSaga(action) {
  try {
    yield call(messageProgress, "Cargando archivo")
    yield call(uploadTemplate, action.payload)

    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))

      data = yield call(uploadTemplateProgress)

      if (data.status === 200) {
        break
      }
    }
    yield call(messageDestroy)
    yield call(uploadTemplateSummary)
    yield call(messageSuccess, "Archivo importado")
    yield put(push("/organization/divisions/summary"))
  } catch (e) {
    yield call(messageDestroy)
    yield call(messageFailed, "Error al importar el archivo")
    yield put(uploadTemplateFailed())
    yield put(push("/organization#divisions"))
  }
}

function saveTemplateApi() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/divisions/import/xlsx/confirm`,
  })
}

function saveTemplateProgressApi() {
  return axios.request({
    method: "get",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/divisions/import/xlsx/confirm/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
  })
}

export function* saveTemplateSaga(action) {
  try {
    yield call(saveTemplateApi)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 200))

      data = yield call(saveTemplateProgressApi)
      yield put(saveTemplateProgress(data))
      if (data.status === 200) {
        yield put(saveTemplateSuccess(data))
        importDivisionSegment(
          "Divisiones cargadas exitosamente",
          action.payload.summary,
          action.payload.attempts
        )
       
        break
      }
    }
  } catch (e) {
    importDivisionSegment(
      "Save Template Error!",
      action.payload.summary,
      action.payload.attempts
    )
  }
}

export function* closeImportSaga() {
  try {
    // yield put(hasDivisionsWatcher())
    yield put(push("/organization/divisions"))
  } catch (e) {}
}

export default function* importDivisionsContainerSaga() {
  yield takeLatest(UPLOAD_TEMPLATE_WATCHER, uploadTemplateSaga)
  yield takeLatest(SAVE_TEMPLATE_WATCHER, saveTemplateSaga)
  yield takeLatest(GET_DIVISIONS_SUMMARY_WATCHER, uploadTemplateSummary)
  yield takeLatest(CLOSE_IMPORT, closeImportSaga)
}
